import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    /**
     * 선택된 환자의 선택된 장비, 선택된 부위와 위치, 의 최초 report용 patientCondition과 범위내에서 최신 patientCondition 두개를 호출
     * {
     *     isSuccess : Boolean,
     *     failedCode : String,
     *     initData : {
     *         aRom : {
     *             date : Datetime,
     *             value : Number,
     *         },
     *         pRomRange : {
     *             date : Datetime,
     *             value : Number,
     *         },
     *         MMT : {
     *             date : Datetime,
     *             value : Number,
     *         }
     *     },
     *     lastData : {
     *         aRom : {
     *             date : Datetime,
     *             value : Number,
     *         },
     *         pRom : {
     *             date : Datetime,
     *             value : Number,
     *         },
     *         MMT : {
     *             date : Datetime,
     *             value : Number,
     *         }
     *     },
     * }
     */
    getInitAndLastPatientConditionForReport( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/report/getInitAndLastPatientConditionForReport';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },
}